export default __webpack_public_path__ + "b69fa7dc1f34be2de38a19cfed031527.png";